// todo: add the others modules
export const VALIDATION_WORKFLOW_MODULE = 'VALIDATION_WORKFLOW';
